"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewMobileSkeleton = void 0;
var _searchPreviewProduct = require("@ori/search-preview-product");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _react = require("react");
var _styles = require("../SearchPreview/styles");
var _constants = require("./constants");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewMobileSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_SKELETON),
    className: className,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_searchPreviewProduct.QueryListSectionSkeleton, {
        numberOfItems: _constants.SUGGESTIONS_COUNT,
        animation: animation,
        itemTestId: _constants.SEARCH_PREVIEW_SKELETON_SUGGESTION,
        queryType: "label"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Section, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.SectionLabelSkeleton, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Products, {
          children: (0, _times.default)(_constants.PRODUCTS_COUNT, index => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledSearchPreviewProductSkeleton, {
              animation: animation
            }), _constants.PRODUCTS_COUNT - 1 === index ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledDivider, {})]
          }, `${_constants.SEARCH_PREVIEW_PRODUCT_SKELETON}-${index}`))
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.StyledQueryListSectionSkeleton, {
        numberOfItems: _constants.BRANDS_COUNT,
        animation: animation,
        itemTestId: _constants.SEARCH_PREVIEW_SKELETON_BRANDS
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles2.StyledQueryListSectionSkeleton, {
        numberOfItems: _constants.CATEGORIES_COUNT,
        animation: animation,
        itemTestId: _constants.SEARCH_PREVIEW_SKELETON_CATEGORIES
      })]
    })
  });
};
exports.SearchPreviewMobileSkeleton = SearchPreviewMobileSkeleton;
